






















import { IDialog } from "@/lib/interfaces/dialog.interface";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { IPersonEmail } from "@/models/person-email.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync } from "vue-property-decorator";
import PersonEmailForm from "./PersonEmailForm.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";

@Component({
  components: {
    PersonEmailForm,
    ConfirmActionDialog
  },
  filters: {}
})
export default class PersonEmailDialog extends mixins(PartnerFallbackMixin) implements IDialog {
  @Prop() value!: IPersonEmail;
  @Prop({ default: "components.partner.PersonEmailDialog.title" }) title!: string;
  @PropSync("isDialogActive", { type: Boolean, required: true }) dialogModel!: boolean;

  isLoading = false;

  isFormValid = false;

  isDialogActive = false;

  open() {
    this.dialogModel = true;
  }

  close() {
    this.dialogModel = false;
  }

  onRightClick() {
    this.$emit("save", this.value);
    this.close();
  }
}
